import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';


import { Restaurant } from './restaurant';
import { RestaurantMenu } from './restaurant-menu';
import { RestaurantEvent } from './restaurant-event';


@Injectable()
export class RestaurantService {

    
}